import { roleAccessReloadVar } from "./state";

export const requestRoleAccessReload = (): void => {
    const currentReloadVersion = roleAccessReloadVar();
    roleAccessReloadVar(currentReloadVersion + 1);
};
